<template>
  <v-container grid-list-sm text-xs-left mt-4>
    <v-layout row wrap justify-left fill-height>
      <v-flex xs12>
        <v-tabs
            v-model="selectedNewsTab"
            color="transparent"
            slider-color="primary"
            centered
        >
          <v-tab
              v-for="newsTab in newsTabs"
              :key="newsTab.id"
              ripple
          >
            <strong>{{ newsTab.name }}</strong>
          </v-tab>
          <v-tab-item
              :key="newsTabs[0].id"
              class="my-2"
          >
            <NewsHomePage/>
          </v-tab-item>

          <v-tab-item
              :key="newsTabs[1].id"
              class="my-2"
          >
            <NewsHomePage
                published
            />

          </v-tab-item>

          <v-tab-item v-if="this.userInfo.role==='APPROVER_INNOVATION'"
              :key="newsTabs[2].id"
              class="my-2"
          >
            <NewsHomePage
                toApprove
            />

          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import NewsHomePage from "@/pages/Admin/Innovation/NewsManagement/NewsHomePage.vue";
import {mapGetters} from "vuex";

export default {
  name: "NewsManagement",
  components: {
    NewsHomePage,
  },
  computed: {
    ...mapGetters("UserState", {
          userInfo: "getUserInfo",
        }
    ),
  },
  created() {
    console.log("Role: ",this.userInfo.role);
    if (this.userInfo.role!=='APPROVER_INNOVATION') {
      this.newsTabs = this.newsTabs.slice(0,2);
    }
  },
  data() {
    return {
      newsTabs: [
        {
          id: 1,
          name: "Unpublished",
          path: "/iadmin/newsManagement/newsHomePage",
        },
        {
          id: 2,
          name: "Published",
          path: "/iadmin/newsManagement/newsHomePage",
        },
        {
          id: 3,
          name: "To Approve",
          path: "/iadmin/newsManagement/newsHomePage",
        },

      ],
      selectedNewsTab: "Unpublished",
    };
  },

}
</script>

<style scoped>

</style>